import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=30fd5ae5&scoped=true&"
import script from "./CatalogSearch.vue?vue&type=script&lang=js&"
export * from "./CatalogSearch.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=30fd5ae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fd5ae5",
  null
  
)

export default component.exports